import * as Data from '../api/archibus-v2/DataApi'
import * as Document from '../api/archibus/DocumentApi'

export const fetchEmployee = ({emId}) => {
  let employee = {}
  let restriction = new Ab.view.Restriction()
  restriction.addClause('em.em_id', emId)

  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'employee',
    restriction
  )
    .then(result => {
      const {data} = result
      if (data && data.length) {
        employee = data[0]
      }

      if (employee.emPhoto) {
        return Document.getTempDocumentUrl(
          'em',
          {em_id: employee.emId},
          'em_photo'
        )
      } else {
        return Promise.resolve(null)
      }
    })
    .then(url => {
      employee.url = url ? encodeURI(url) : null

      return Promise.resolve(employee)
    })
}
